import _defineProperty from "@babel/runtime/helpers/defineProperty";
/*
 *                     NOTICE
 *            COPYRIGHT 2021 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { AbColorPicker } from "abreact/misc/AbColorPicker";
class AbMarkdownColorPlugin {}
_defineProperty(AbMarkdownColorPlugin, "parseColor", (state, silent) => {
  // PORTAL-1304: color strings are allowed to include parens and dashes
  const open_reg = /^{(\w+)\s*:\s*([\w()-]+)}/; // opencurly word : letters-dashes-or-parens closecurly
  const close_reg = /^{(\w+)}/; // opencurly word closecurly
  const ab_global_color_reg = /^var\(--ab-global-color-([^)]*)\)/; // for example, var(--ab-global-color-white)
  let start = state.pos;
  // leave if we're not looking at an open curly bracket
  if (state.src.charCodeAt(start) !== 0x7B) {
    return false;
  }
  const match_open = open_reg.exec(state.src.slice(start));
  if (match_open) {
    const kind = match_open[1];
    let color = match_open[2];
    // PORTAL-1304: if the markdown is '{color:var(--ab-global-color-foo)}' then the color is 'foo'.
    const match_ab_global_color = ab_global_color_reg.exec(color);
    if (match_ab_global_color) {
      color = match_ab_global_color[1];
    }
    let token = {
      type: `${kind}_${color}_open`,
      // for example: "color_red_open", or "background_teal-500_open"
      level: state.level++,
      content: {
        open: true,
        kind,
        color
      }
    };
    // Make sure the color is known. If not, it's text.
    let validColor;
    const dashPos = color.indexOf("-");
    if (dashPos > 0) {
      validColor = AbColorPicker.abinitioColors.includes(color.substring(0, dashPos)) && color.substring(dashPos + 1).match(/^[1-9]00$/) != null;
    } else {
      validColor = AbColorPicker.simpleColors.includes(color);
    }
    if (!validColor) {
      return false;
    }
    state.push(token);
    state.pos += match_open[0].length;
    return true;
  }
  const match_close = close_reg.exec(state.src.slice(start));
  if (match_close) {
    const kind = match_close[1];
    let color = ""; // look backwards for the last open of the same kind
    for (let i = state.tokens.length - 1; i >= 0; i--) {
      if (state.tokens[i].content && state.tokens[i].content.open && state.tokens[i].content.kind === kind) {
        color = state.tokens[i].content.color;
        break;
      }
    }
    if (color !== "") {
      // if we didn't find the last open of the same kind, the close is just text.
      let token = {
        type: `${kind}_${color}_close`,
        // for example, color_red_close
        level: --state.level
      };
      state.push(token);
      state.pos += match_close[0].length;
      return true;
    }
  }
  return false;
});
export function abMarkdownColorPlugin(md, options) {
  // Add to inline rules: convert {color:foo} to token "color_red_open", and {color} to "color_red_close".
  md.inline.ruler.push("colors", AbMarkdownColorPlugin.parseColor, {});

  // AbMarkdownReactRenderer handles colors.
}
//# sourceMappingURL=AbMarkdownColorPlugin.js.map
